import { removeInitialZeros } from '@/utils/removeInitialZeros';
import { DEFAULT_CURRENCY_PRECISION } from '../constants';

export const parseInputValueToFloatString = (value: string, precision = DEFAULT_CURRENCY_PRECISION) => {
  const onlyDigitsValue = value.replace(/\D/g, '');

  const valueWithMinimalPrecision = onlyDigitsValue.padStart(precision, '0');

  const integerPart = removeInitialZeros(
    valueWithMinimalPrecision.substring(0, valueWithMinimalPrecision.length - precision),
  ).padStart(1, '0'); // Add min quantity of zeros at the start

  const parsedValue = `${integerPart}.${valueWithMinimalPrecision.slice(precision * -1)}`;

  return parsedValue;
};
